import { Component, OnInit } from '@angular/core';
import { EngageService } from '../engage.service';
import { DataTable, IDataClassConfig } from 'app/classes/data-table/data-table';

@Component({
  selector: 'app-engage-users',
  templateUrl: './engage-users.component.html',
  styleUrls: ['./engage-users.component.css'],
  standalone: false
})
export class EngageUsersComponent implements OnInit {
  users: any[];

  dataTable: DataTable;
  dataTableConfig: IDataClassConfig = {
    "name": { "valueType": "string", "title": "Name", "align": "left" },
    "orgShortTitle": { "valueType": "string", "title": "Organisation", "align": "left" },
    "siteCount": { "valueType": "number", "title": "Sites", "align": "right" }
  };

  constructor(private engageService: EngageService) {

    engageService.getUsers()
      .then(users => {
        this.users = users;
        this.dataTable = new DataTable({ data: this.users }, this.dataTableConfig);
      });
  }

  ngOnInit() {
  }

}
